module.exports = __webpack_public_path__ + "img/metroidvania06.08122d92.jpg";